var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { statusColors } from 'syf-component-library/defaultTheme';
import NotificationBar from 'syf-component-library/ui/patterns/NotificationBar';
import { spacing } from '../../../../styles/theme';
export var StyledNotificationBar = styled(NotificationBar)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", "px;\n  border-radius: 10px;\n  border: 1px solid ", ";\n"], ["\n  padding: ", "px;\n  border-radius: 10px;\n  border: 1px solid ", ";\n"])), spacing.small, statusColors.warning.border);
var templateObject_1;
//# sourceMappingURL=subcomponents.js.map